import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "@heroicons/react/solid";

function Alert(props) {
    const { active, close, text, type, className, marginLess, children } = props;

    const [activeState, setActiveState] = useState();

    const getStyle = () => {
        switch (type) {
            case ALERT_TYPE.ERROR:
                return "bg-red-100 text-red-700";
            case ALERT_TYPE.WARNING:
                return "bg-amber-100 text-amber-700";
            case ALERT_TYPE.SUCCESS:
                return "bg-green-100 text-green-700";
            case ALERT_TYPE.NEUTRAL:
                return "bg-blue-100 text-blue-700";
            default:
                return "bg-red-100 text-red-700";
        }
    };

    useEffect(() => {
        if (active) {
            setActiveState(true);

            if (close) {
                const timeId = setTimeout(() => {
                    // After 30 seconds set the show value to false
                    setActiveState(false);
                    close();
                }, 30000);

                return () => {
                    clearTimeout(timeId);
                };
            }
        }
    }, [active, close]);

    return (
        <AnimatePresence>
            {active && activeState && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div
                        className={
                            "rounded-md px-3 py-3 shadow-sm " +
                            (marginLess ? "my-0 " : "my-3 ") +
                            getStyle() +
                            (className == null ? " w-full" : " " + className)
                        }
                    >
                        <div className="flex gap-4 text-sm justify-between">
                            {text}
                            {close && (
                                <button type="button" className="focus:outline-none place-self-top" onClick={close}>
                                    <XIcon className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                        {children}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default Alert;

export const ALERT_TYPE = { SUCCESS: 1, ERROR: 2, WARNING: 3, NEUTRAL: 4 };
